import { render, staticRenderFns } from "./DateView.vue?vue&type=template&id=5373d8b5&scoped=true"
import script from "./DateView.vue?vue&type=script&lang=js"
export * from "./DateView.vue?vue&type=script&lang=js"
import style0 from "./DateView.vue?vue&type=style&index=0&id=5373d8b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5373d8b5",
  null
  
)

export default component.exports